<template>
  <div>
    <router-view v-show="$route.matched.length == 3"></router-view>
    <PageHeaderLayout v-show="$route.matched.length == 2">
      <div class="main-page-content">
        <el-row>
          <el-col :span="18">
            <span>
            每月15日前申报上月全部个税，当前申报日期：{{ lastMounth }}月1日-{{
              lastMounth
            }}月15日;
          </span>
          <span style="color:#F56C6C;">
            未在规定时间内缴纳则产生滞纳金。
          </span>
          </el-col>
          <el-col :span="6">
            <div style="display: flex;">
              <exportDeclare :search="{month: searchCondition.time}"></exportDeclare>
            <exportEmployee :search="{month: searchCondition.time}"></exportEmployee>
            </div>
           

          </el-col>
        </el-row>

        <el-row class="table-search">
          <el-form size="medium" :inline="true" :model="searchCondition">
            <el-form-item label="所属年月" prop="time" size="small">
              <el-date-picker
                :clearable="false"
                v-model="searchCondition.time"
                type="month"
                placeholder="选择月"
                value-format="yyyy-MM"
                format="yyyy-MM"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item label="申报状态" prop="declare_status" size="small">
              <el-select clearable v-model="searchCondition.declare_status">
                <el-option label="待申报" value="0"></el-option>
                <el-option label="申报中" value="1"></el-option>
                <el-option label="申报成功" value="2"></el-option>
                <el-option label="申报失败" value="3"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="缴纳状态" prop="pay_status" size="small">
              <el-select clearable v-model="searchCondition.pay_status">
                <el-option label="待缴纳" value="0"></el-option>
                <el-option label="已缴纳" value="1"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="服务类型" prop="status" size="small">
              <el-select clearable v-model="searchCondition.status">
                <el-option label="服务劳务" value="0"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button
                type="primary"
                @click="searchButton"
                :disabled="disabled"
                >查询</el-button
              >
            </el-form-item>
            <el-form-item>
              <el-button
                type="primary"
                @click="clickDeclaration"
                :disabled="disabled || isCanDeclare()"
                >一键申报</el-button
              >
              <el-button
                type="danger"
                @click="declareCancel"
                :disabled="disabled || isCanDeclare()"
                >作废</el-button
              >
              <el-button
                type="success"
                @click="declarePay"
                :disabled="disabled || isCanDeclare()"
                >缴纳</el-button
              >
              <el-button
                type="warning"
                @click="declareEdit"
                :disabled="disabled || isCanDeclare()"
                >修改</el-button
              >
              <el-button
                style="margin-left: 24px;"
                :loading="downloadLoading"
                type="primary"
                icon="el-icon-document"
                @click="handleDownload"
              >
                导出
              </el-button>
            </el-form-item>
          </el-form>
        </el-row>
        <ApeTable
          ref="apeTable"
          :data="dataList"
          :columns="columns"
          :loading="loadingStaus"
          :pagingData="pagingData"
          @switchPaging="switchPaging"
          highlight-current-row
        >
          <el-table-column
            v-if="buttonType == 'text'"
            width="250"
            header_align="center"
            align="center"
            label="操作"
          >
            <template slot-scope="scope">
              <span>
                <el-button
                  size="mini"
                  type="primary"
                  v-if="userPermissions.indexOf('task_detail') != -1"
                  @click="viewButton(scope.row.id)"
                  :disabled="disabled"
                  >查看</el-button
                >
              </span>
            </template>
          </el-table-column>
        </ApeTable>
      </div>
    </PageHeaderLayout>
    <ModalDialog
      :dialogData="dialogData"
      :showButton="showButton"
      @dialogClose="dialogClose"
    >
      <template slot="content">
        <div class="declare-details">
          <div>
            <div class="title">基础信息</div>
            <div class="basis-info">
              <div>姓名：李三</div>
              <div>服务类型：市场推广服务</div>
              <div>证件号码：230xxxxxxxxxxx0031</div>
              <div>手机号码：135xxxx9967</div>
              <div>地址：浙江省杭州市</div>
            </div>
          </div>
          <div>
            <div class="title">计税明细</div>
            <div class="tax-details">
              <div>计税依据：6000.00元(收入)-800.00元(扣税额)=5200元</div>
              <div>适用税率：20%(劳务报酬税率表)</div>
              <div>应缴税额：5200×20%=1040(已预缴:0元→本期应补缴:1040元)</div>
              <div>规则来源：《个人所得税法》劳务报酬计税规则(2025版)</div>
            </div>
          </div>
          <div>
            <div class="title">关联凭证</div>
            <div class="voucher">
              <div>发票号码：xxxxxx</div>
              <div>开票金额：6000.00元</div>
              <div>税额：360元(增值税)</div>
            </div>
          </div>
          <div>
            <div class="title">申报状态</div>
            <div class="declare-status">
              <div>
                <div>申报时间：2025-08-15 12:24:23</div>
                <div>状态：申报成功</div>
              </div>
              <div>操作日志：</div>
              <div>2025-08-15 14:22:22 李三 发起申报</div>
            </div>
          </div>
        </div>
      </template>
    </ModalDialog>
  </div>
</template>

<script>
import moment from "moment";
import PageHeaderLayout from "@/layouts/PageHeaderLayout";
import ApeTable from "@/components/ApeTable";
import ApeDrawer from "@/components/ApeDrawer";
import ApeUploader from "@/components/ApeUploader";
import ModalDialog from "@/components/ModalDialog";
import DatePicker from "@/components/DatePicker.vue";
import { mapGetters } from "vuex";
import { debounce } from "lodash";
import exportDeclare from "./components/exportDeclare";
import exportEmployee from "./components/exportEmployee";

export default {
  components: {
    PageHeaderLayout,
    ApeDrawer,
    ApeTable,
    ApeUploader,
    ModalDialog,
    DatePicker,
    exportDeclare,
    exportEmployee
  },
  data() {
    let nowDate = new Date();
    let lastDate =
      nowDate.getFullYear() +
      "-" +
      `${
        nowDate.getMonth() < 10 ? `0${nowDate.getMonth()}` : nowDate.getMonth()
      }`;
    return {
      lastMounth:
        nowDate.getMonth() + 1 < 10
          ? `0${nowDate.getMonth() + 1}`
          : nowDate.getMonth() + 1,
      nowsettlementInfo: localStorage.getItem("nowsettlementInfo")
        ? JSON.parse(localStorage.getItem("nowsettlementInfo"))
        : {},
      monthList: [],
      disabled: false,
      showButton: ["cancel", "determine"], // 不显示弹窗框的按钮
      tableData: [],
      tableHeader: [],
      declareList: [],
      // 搜索条件
      searchCondition: {
        time: lastDate,
      },
      loadingStaus: true,
      columns: [
        {
          title: "姓名",
          value: "bank_account_name",
          header_align: "center",
          align: "center",
        },
        {
          title: "收款账号",
          value: "bank_account_no",
          header_align: "center",
          align: "center",
        },
        {
          title: "下发通道",
          value: "yl_bank_name",
          header_align: "center",
          align: "center",
        },
        {
          title: "附属信息",
          width: 300,
          value: [
            // { label: "证件类型：", value: "alias_id_type" },
            { label: "证件号码：", value: "id_number" },
            { label: "手机号码：", value: "mobile" },
            { label: "地址：", value: "id_address" },
          ],
          header_align: "center",
        },
        {
          title: "服务类型",
          value: "category_name",
          header_align: "center",
          align: "center",
        },
        {
          title: "结算金额",
          value: "money",
          header_align: "center",
          align: "center",
        },
        {
          title: "预扣增值税和附加税",
          value: "added_tax_money",
          header_align: "center",
          align: "center",
        },
        {
          title: "个税",
          value: "accumulate_tax_money",
          header_align: "center",
          align: "center",
        },
        {
          title: "申报状态",
          type: "status",
          value: "declare_status",
          header_align: "center",
          align: "center",
          propData: {
            0: "待申报",
            1: "申报中",
            2: "申报成功",
            3: "申报失败",
          },
        },
        {
          title: "缴纳状态",
          type: "status",
          value: "pay_status",
          header_align: "center",
          align: "center",
          propData: {
            0: "待缴纳",
            1: "已缴纳",
          },
        },
        {
          title: "申报时间",
          value: "declare_time",
          header_align: "center",
          align: "center",
          // width: 170
        },
      ],
      // 表格列表数据
      dataList: [],
      // 分页信息
      pagingData: {
        is_show: true,
        layout: "total, sizes, prev, pager, next, jumper",
        total: 0,
      },
      // 分页的offset,序号列使用
      offset: 0,
      // 添加附件
      dialogData: {
        visible: false,
        title: "申报明细",
        width: "35%",
        loading: false,
        modal: false,
      },
      isShow: false, //是否模糊页面
      downloadLoading: false,
    };
  },
  computed: {
    ...mapGetters(["userPermissions", "buttonType"]),
  },
  watch: {
    "$route.matched": function(n, o) {
      console.log(o);
      if (n.length === 2) {
        this.init();
      }
    },
  },
  methods: {
    isCanDeclare() {
      let canDeclareTime = new Date();
      canDeclareTime.setDate(1);
      canDeclareTime = moment(canDeclareTime).format("YYYY-MM-DD");
      canDeclareTime = new Date(canDeclareTime).getTime();
      let selectDate = new Date(this.searchCondition.time + "-01").getTime();
      return selectDate >= canDeclareTime;
    },
    // 一键申报
    clickDeclaration() {
      if (!this.pagingData.total) {
        this.$message("暂无可申报数据");
        return;
      }
      const h = this.$createElement;
      this.$msgbox({
        title: "提示",
        message: h("p", null, [
          h(
            "div",
            { style: "text-align: center;font-size:18px" },
            `确认申报 ${this.searchCondition.time} 月的 ${this.pagingData.total} 条数据？`
          ),
          h(
            "div",
            { style: "text-align: center;font-size:18px" },
            `总税额 ${this.total_money} 元`
          ),
        ]),
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        callback: async (action) => {
          if (action === "confirm") {
            this.clickDeclarationFun();
          }
        },
      });
    },
    clickDeclarationFun: debounce(
      async function() {
        let res = await this.$api.declareSubmit({
          date: this.searchCondition.time.replace(/-/, ""),
        });
        console.log(res);
        this.init();
      },
      2000,
      { leading: true, trailing: false }
    ),
    dialogClose() {
      this.dialogData.visible = false;
    },
    // 作废
    declareCancel() {
      if (!this.pagingData.total) {
        this.$message("暂无可作废数据");
        return;
      }
      const h = this.$createElement;
      this.$msgbox({
        title: "提示",
        message: h("p", null, [
          h(
            "div",
            { style: "text-align: center;font-size:18px" },
            `确认作废该条申报？`
          ),
        ]),
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        callback: async (action) => {
          if (action === "confirm") {
           this.declareCancelFun()
          }
        },
      });
    },
    declareCancelFun:debounce(
      async function() {
        let res = await this.$api.declareCancel({
          date: this.searchCondition.time.replace(/-/, ""),
        });
        console.log(res);
        this.init();
      },
      2000,
      { leading: true, trailing: false }
    ),
    // 缴纳
    declarePay() {
      if (!this.pagingData.total) {
        this.$message("暂无可缴纳信息");
        return;
      }
      const h = this.$createElement;
      this.$msgbox({
        title: "提示",
        message: h("p", null, [
          h(
            "div",
            { style: "text-align: center;font-size:18px" },
            `确认缴纳该税费？`
          ),
        ]),
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        callback: async (action) => {
          if (action === "confirm") {
            this.declarePayFun()
          }
        },
      });
    },
    declarePayFun:debounce(
      async function() {
        let res = await this.$api.declarePay({
          // channelName: this.nowsettlementInfo.name,
          month: this.searchCondition.time.replace(/-/, ""),
        });
        console.log(res);
        this.init();
      },
      2000,
      { leading: true, trailing: false }
    ),
    // 修改申报
    declareEdit() {
      const h = this.$createElement;
      this.$msgbox({
        title: "提示",
        message: h("p", null, [
          h(
            "div",
            { style: "text-align: center;font-size:18px" },
            `确认更正该条申报吗？`
          ),
        ]),
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        callback: async (action) => {
          if (action === "confirm") {
            this.declareEditFun()
          }
        },
      });
    },
    declareEditFun:debounce(
      async function() {
        let res = await this.$api.declareUpdate({
          date: this.searchCondition.time.replace(/-/, ""),
        });
        console.log(res);
        this.init();
      },
      2000,
      { leading: true, trailing: false }
    ),
    async handleDownload() {
      this.downloadLoading = true;
      let list = this.dataList;
      import("@/excel/Export2Excel").then((excel) => {
        let sHeader = [];
        this.columns.map((item) => {
          if (typeof item.value == "object") {
            item.value.map((item1) => {
              sHeader.push(item1.label);
            });
          } else {
            sHeader.push(item.title);
          }
        });
        const data = this.formatJson(list);
        console.log(data, "data");
        const time = new Date().getTime() + Math.random() * 1000;
        let filename = `个税申报${time}`;
        excel.export_json_to_excel({
          header: sHeader, //Header Required
          data, //Specific data Required
          filename: filename, //Optional
          autoWidth: true, //Optional
          bookType: this.exportType, //Optional
        });
        this.downloadLoading = false;
      });
    },
    formatJson(jsonData) {
      return jsonData.map((v) => {
        let arr = [];
        this.columns.map((item) => {
          if (typeof item.value == "object") {
            item.value.map((item1) => {
              arr.push(v[item1.value]);
            });
          } else if (item.type == "status") {
            arr.push(item.propData[v[item.value]]);
          } else {
            arr.push(v[item.value]);
          }
        });
        return arr;
      });
    },
    // 重置分页
    async resetPage() {
      this.$refs.apeTable.currentPage = 1;
    },
    // 搜索
    searchButton() {
      this.init("search");
    },
    // 切换页码操作
    async switchPaging() {
      this.init();
    },
    // 响应详情按钮
    async viewButton(id) {
      this.$router.push({
        path: this.$route.path + "/declareView",
        query: {
          id,
        },
      });
    },
    //获取选中日期的值
    dataSearch(value) {
      this.searchCondition.time_value = value;
    },
    // 初始化列表
    async init(type) {
      this.loadingStaus = true;
      let pagingInfo = this.$refs["apeTable"].getPagingInfo(type);
      if (type) {
        pagingInfo.current_page = 1;
      }
      let searchCondition = this.handleSearchCondition();
      Object.assign(searchCondition, pagingInfo);
      let { list, pages, total_money } = await this.$api.getPersonalDeclareList(
        searchCondition
      );
      this.dataList = list;
      this.pagingData.total = pages.total;
      this.total_money = total_money;
      this.offset = pages.offset;
      this.loadingStaus = false;
    },
    // 处理搜索条件
    handleSearchCondition() {
      let condition = {};
      console.log(this.searchCondition);
      if (this.searchCondition.time) {
        condition.date = this.searchCondition.time.replace(/-/g, "");
      }
      if (this.searchCondition.declare_status) {
        condition.declare_status = this.searchCondition.declare_status;
      }
      if (this.searchCondition.pay_status) {
        condition.pay_status = this.searchCondition.pay_status;
      }
      return condition;
    },

    keyupSubmit() {
      document.onkeydown = (e) => {
        console.log(e);
        let _key = window.event.keyCode;
        if (_key === 13) {
          this.searchButton();
        }
      };
    },
  },
  created() {
    this.keyupSubmit();
  },
  mounted() {
    this.init();
  },
};
</script>

<style lang="scss" scoped>
.declare-details {
  font-size: 18px;
  color: #3d3d3d;
  & > div {
    padding: 16px 10px;
    & + div {
      border-top: 1px solid #d8d8d8;
    }
  }
  .title {
    margin-bottom: 10px;
    font-size: 22px;
    color: #171717;
  }
  .basis-info {
    display: flex;
    flex-flow: row wrap;
    & > div {
      width: 50%;
      margin-top: 10px;
    }
  }
  .tax-details {
    & > div {
      margin-top: 10px;
    }
  }
  .voucher {
    display: flex;
    & > div {
      flex: 1;
      margin-top: 10px;
    }
  }
  .declare-status {
    & > div {
      margin-top: 10px;
      &:first-child {
        display: flex;
        justify-content: space-between;
        & > div {
          flex: 1;
        }
      }
    }
  }
}
</style>
